import React from "react";

export default function JiliQuestTNC({ onClose }) {
	return (
		<div className="game-rush-tnc">
			<div className="game-rush-tnc--dialog">
				<div className="game-rush-tnc--content">
					<header className="game-rush-tnc--header">
						<h1>Terms and Conditions</h1>
						<p>Sept 01 (12PM) - Sept 29 (11:59AM), 2026</p>
					</header>

					<section className="jili-quest-tnc">
						<ol>
							<li>This promotion is open to all eligible FGH players.</li>
							<li>
								Eligible players may join the promotion at any time during the
								promotion period and will begin from Stage 1.
							</li>
							<li>
								Players must complete stages sequentially. Skipping stages is
								not allowed.
							</li>
							<li>
								Only turnover generated on the currently unlocked stage's
								assigned game will count toward stage progression.
							</li>
							<li>
								The first stage of each weekly stage set will become available
								according to the promotion schedule. Remaining stages within the
								same week will unlock sequentially after the previous stage has
								been completed.
							</li>
							<li>
								Rewards will be automatically credited immediately after
								successful completion of each stage.
							</li>
							<li>
								Free Spins and Free Credits are non-transferable,
								non-exchangeable, and cannot be converted into cash unless
								otherwise stated. Their usage and validity are subject to the
								platform's promotional rules.
							</li>
							<li>
								The operator reserves the right to verify player eligibility,
								replace unavailable games with other eligible JILI games, and
								amend, suspend, or cancel the promotion when necessary.
							</li>
							<li>
								By participating in this promotion, players agree to these Terms
								& Conditions and the operator's general gaming rules.
							</li>
						</ol>
					</section>

					<header className="game-rush-tnc--header">
						<h1>Promotion Mechanics</h1>
					</header>

					<section className="jili-quest-tnc">
						<ol>
							<li>
								The promotion runs for 4 consecutive weeks, and eligible players
								may join anytime during the promotion by starting at Stage 1.
							</li>
							<li>
								Complete each stage in order to unlock the next, with 5 stages
								released each week. First stage of the following weeks will open
								automatically like stage 1.
							</li>
							<li>
								Only turnover generated on the currently unlocked stage's
								assigned game will count toward stage completion. Excess
								turnover will not carry over to the next stage.
							</li>
							<li>
								Upon meeting the required turnover for the current stage, the
								stage will be marked as completed, the corresponding reward will
								be automatically credited, and the next available stage will
								unlock.
							</li>
							<li>
								Free Spins and Free Credits will be credited automatically after
								stage completion. They may be used on all eligible promotion
								games and and will expire one week after the promo ends.
							</li>
							<li>
								Players may continue progressing until the end of the promotion
								period. Any incomplete stages remaining after the promotion ends
								will be forfeited.
							</li>
						</ol>
					</section>
				</div>

				<div className="game-rush-tnc--close-btn">
					<button type="button" onClick={onClose}>
						Close
					</button>
				</div>
			</div>
		</div>
	);
}
